// Faithful ms -> "m:ss" formatter. Coerces string durations (stored as String
// in the DB). No clamp: a real value must round-trip, since this string is also
// parsed back to ms on the duration write path.
export function formatMs(ms) {
  let v = Number(ms);
  if (!Number.isFinite(v) || v < 0) v = 0;
  const total = Math.floor(v / 1000);
  const m = Math.floor(total / 60);
  const s = total % 60;
  return `${m}:${String(s).padStart(2, "0")}`;
}

// Sum content-item durations. `duration` is stored as a String, so coerce each
// to Number before adding — otherwise `+` string-concatenates into a garbage total.
export function sumDurationsMs(content) {
  if (!Array.isArray(content)) return 0;
  return content.reduce((sum, item) => sum + (Number(item?.duration) || 0), 0);
}
